module.exports = __webpack_public_path__ + "03_face.f6c0d543.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer1/03_face.png
// module id = ikkE
// module chunks = 0